import { render } from "./BackLink.vue?vue&type=template&id=db501aae"
import script from "./BackLink.vue?vue&type=script&lang=js"
export * from "./BackLink.vue?vue&type=script&lang=js"
script.render = render

export default script